import { Item } from 'shared-types/Common';
import type { Item as EventItem } from '@common/components/ItemListingRows/Event/Event';
import type { Item as VoucherItem } from '@common/components/ItemListingRows/Voucher/Voucher';

export function isVoucher(item: Item | VoucherItem | EventItem): item is VoucherItem {
  return (item as VoucherItem).type === 'vouchers';
}

export function isEvent(item: Item | VoucherItem | EventItem): item is EventItem {
  return (item as EventItem).type === 'events';
}
